class ItemInventorySettingsModel {
  private _serverData: any;

  constructor(serverData: any = null) {
    this._serverData = serverData;
  }

  get inventory_enabled(): boolean {
    return Boolean(this._serverData?.inventory_enabled);
  }

  get reorder_level(): string {
    const value = this._serverData?.reorder_level;
    return value === null || value === undefined ? '0' : String(value);
  }

  get target_level(): string {
    const value = this._serverData?.target_level;
    return value === null || value === undefined ? '0' : String(value);
  }

  toFormValues() {
    return {
      inventory_enabled: this.inventory_enabled,
      reorder_level: this.reorder_level,
      target_level: this.target_level,
    };
  }

  static fromServerData(serverData: any) {
    return new ItemInventorySettingsModel(serverData);
  }

  static createEmpty() {
    return new ItemInventorySettingsModel();
  }
}

export default ItemInventorySettingsModel;
